module.exports = __webpack_public_path__ + "static/media/instagram-logo-2.af4e84bf.svg";